import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("rr_user")) || null; } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (username, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { username, password });
      localStorage.setItem("rr_token", data.token);
      localStorage.setItem("rr_user", JSON.stringify({ username: data.username }));
      setUser({ username: data.username });
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e.response?.data?.detail || "Login gagal" };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("rr_token");
    localStorage.removeItem("rr_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
